import { Injectable } from '@angular/core';
import { DynamicFormModel } from "../models/dynamic-form-model";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  formModel: DynamicFormModel[] = [];
  constructor() { }
}
